import { Component, Prop, Ref, SimpleEvent, Watch } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { cart } from '@/theme/Cart';
import { setVariantUrlParam } from '@/utils/products';
import { ProductOptionPicker } from '@/components/Product/ProductOptionPicker';
import { LinkedSubscriptions } from '@/components/LinkedSubscriptions/LinkedSubscriptions';
import { isTemplateExpression } from 'typescript';

@Component
export class SubscriptionForm2 extends ThemeComponent {

    @Prop freeGifts!: [];

    @Ref({required: false}) options!: ProductOptionPicker;
    @Ref({required: false}) actions!: HTMLDivElement;
    @Ref({required: false}) submitButton!: HTMLButtonElement[];
    @Ref({required: false}) chargeDelayInput!: HTMLInputElement;
    @Ref({required: false}) fineprint!: HTMLDivElement;
    @Ref error!: HTMLElement;
    @Ref errorMessage!: HTMLElement;

    protected loading: boolean = false;
    protected selectedProductId: number|null;
    protected productFeaturesJson: string|null;
    protected quantity: number = 1;
    protected selectedVariant: ShopifyVariant|null = null;

    private _onProductChange = new SimpleEvent<string>();
    public get onProductChange() {
        return this._onProductChange.asEvent();
    }

    selectedProductFrequency: string|null;

    constructor() {
        super();
        this.selectedProductFrequency = null;
        this.selectedProductId = null;
        this.productFeaturesJson = null;
    }

    /**
     * Initiaze compoenent.
     */
    init() {
        // Set default variant
        this.setEventListeners();
    }

    updateSelectedFrequency(frequency: string) {
        this.selectedProductFrequency = frequency;
        this._onProductChange.dispatch(frequency);
        this.updateFineprint(frequency);
    }

    /**
     * Set event listeners.
     */
    protected setEventListeners() {
        this.listenSubmitClick();
    }


    /**
     * Listen for submit button click.
     */
    protected listenSubmitClick() {

        // Listen for form submission
        if (this.submitButton) {

            for (const button of this.submitButton) {


                const inventoryQty = button.getAttribute('inventory');
                const continueSellingOFS = button.getAttribute('continue_selling_ofs');

                if (continueSellingOFS == 'false' && Number(inventoryQty) <= 0) {
                    button.disabled = true;
                }else {
                    this.$listen(button, 'click', () => {
                        const subscription = button.getAttribute('is_subscription');

                        this.productFeaturesJson = null;

                        const quantity = button.getAttribute('quantity');

                        if (quantity) {
                            this.quantity = Number(quantity);
                        }

                        const properties: {[key: string]: string} = {};
                        let selected_value = 'onetime';

                        /* eslint-disable-next-line */
                        let subscription_selected:HTMLInputElement|null = this.querySelector('input[name="purchase_type"]:checked');
                        this.selectedProductId = Number(subscription_selected?.getAttribute('data-variant-id'));


                        if (subscription_selected && subscription_selected.getAttribute('data-features-json')) {
                            this.productFeaturesJson = subscription_selected.getAttribute('data-features-json');
                        }

                        if (subscription === 'true') {
                            if (!subscription_selected) {
                                subscription_selected = this.querySelector('input[name*="selling_plan_"]:checked');
                                this.selectedProductId = Number(subscription_selected?.getAttribute('data-variant-id'));
                            }

                            if (subscription_selected !== null) {
                                selected_value = subscription_selected.value;
                                this.selectedProductId = Number(subscription_selected.getAttribute('data-variant-id'));
                            }

                            if (selected_value == 'autodeliver' || selected_value == 'subsave') {
                                this.checkRechargeVersions(button, properties);
                                return;
                            }

                        }else {
                            const checkout_image_url: string|null = button.getAttribute('checkout_image');
                            if (checkout_image_url) {
                                properties['checkout_image'] = checkout_image_url;
                            }
                        }

                        if (this.selectedProductId) {
                            this.addToCart(button, this.selectedProductId, properties, null).catch((e) => {
                                this.$log.error(`Add to cart failed`, { e });
                            });
                        }
                    });
                }
            }
        }
    }

    /**
     * Check ReCharge Payments App Version.
     * - Background: In November 2020 Recharge updated the app to use shopify plans
     * instead of a separate recharger chechout. The implementation is slightly different
     * if the App was installed before/after November 2020.
     * - The below script checks for which implementation to use (rechargeCheckout or shopifyPlans)
     * - Learn more: https://support.rechargepayments.com/hc/en-us/articles/360008681834
     * @param value - selected value.
     * @returns
     */
    protected checkRechargeVersions(button: HTMLElement, properties: {[key: string]: string}) {
        const sellingPlan:string|null = button.getAttribute('selling_plan');
        if (!sellingPlan) {
            this.handleCartItemProperties(button, properties, false, null);
            return;
        }

        this.handleCartItemProperties(button, properties, true, sellingPlan);
    }

    /**
     * Handle cart item properties, then send cart data.
     * @param properties - product properties.
     * @param isSellingPlan - check if it has selling plan
     * @param sellingPlan - selling plan id.
     * @returns
     */
    handleCartItemProperties(
        buttonType: HTMLElement,
        properties: {[key: string]: string},
        isSellingPlan:boolean,
        sellingPlan:string|null
    ) {
        const frequency:string|null = buttonType.getAttribute('frequency');
        const pack_size:string|null = buttonType.getAttribute('quantity');
        const unit_type:string|null = buttonType.getAttribute('unit_type');
        const parent_product_title:string|null = buttonType.getAttribute('parent_product_title');
        const parent_product_url:string|null = buttonType.getAttribute('parent_product_url');
        const upsellId:string|null = buttonType.getAttribute('upsell_id') || "";
        const chargeDelay:string|null = this.chargeDelayInput.value || "";
        const hide_qty:string|null = buttonType.getAttribute('_hide_qty') || "";
        const charge_delay_experiment: string|null = buttonType.getAttribute('charge_delay_experiment');

        /* eslint-disable */
        properties = {
            'shipping_interval_frequency': frequency || '',
            'pack_size': pack_size || '',
            'shipping_interval_unit_type': unit_type || '',
            '_parent_product_title': parent_product_title || '',
            '_parent_product_url': parent_product_url || '',
            '_upsell_id': upsellId,
            'charge_delay': chargeDelay || '0',
            '_hide_qty': hide_qty || 'false',
            'charge_delay_experiment': charge_delay_experiment || '',
        };
        /* eslint-enable */

        // Recharge products show a different quantity to the user
        // so we need to set the quantity that the user
        // sees as a property which we can then display

        if (this.quantity) {
            properties['_display_quantity'] = `${this.quantity}`;
        }

        if (this.productFeaturesJson) {
            properties['_features'] = this.productFeaturesJson;
        }

        if (isSellingPlan) {
            this.addToCart(
                buttonType,
                this.selectedProductId,
                properties,
                sellingPlan
            ).catch((e) => {
                this.$log.error(`Add to cart failed`, { e });
            });
            return;
        }

        this.checkVariantId(buttonType, properties);
    }

    /**
     * Check if adding subscription product and update variant id accordingly.
     * - This method is for recharge checkout implementation.
     * @param properties - product properties.
     * @returns
     */
    protected checkVariantId(buttonType:HTMLElement, properties: {[key: string]: string}) {
        const variant:number|null = this.selectedProductId;

        if (!variant) {
            this.showError(`Please select an option.`);
            return;
        }

        if (!buttonType) { return; }
        const subscriptionsString = buttonType.getAttribute('subscriptions_json');
        const json = JSON.parse(String(subscriptionsString));
        const updatedVariant = json[variant].discount_variant_id;
        this.addToCart(buttonType, updatedVariant, properties, null).catch((e) => {
            this.$log.error(`Add to cart failed`, { e });
        });
    }

    /**
     * Show error
     * @param msg - error message.
     */
    protected showError(msg: string|null): void {
        this.errorMessage.textContent = msg;
        if (msg) {
            this.error.classList.add('product-form__error--active');
        } else {
            this.error.classList.remove('product-form__error--active');
        }
    }

    /**
     * Add product to cart.
     * @param variant
     * @param properties
     * @returns
     */
    protected async addToCart(
        submitButtonType: HTMLElement,
        variant:number|null,
        properties: {[key: string]: string},
        sellingPlan:string|null
    ) {
        try {
            this.loading = true;

            // Check variant exists
            if (!variant) {
                this.showError(`Please select an option.`);
                return;
            }

            if (this.productFeaturesJson) {
                properties['_features'] = this.productFeaturesJson;
            }

            // Define selling plan
            const sanitizedPlan = sellingPlan?Number(sellingPlan): undefined;
            const freeGifts = this.freeGifts != undefined ? this.freeGifts.filter((item) => item) : [];

            let hasGift = false;

            let variantFormInput
            = document.querySelector(`[data-discount-variant-id="${variant}"]`) as HTMLInputElement;

            if (!variantFormInput) {
                variantFormInput
                = document.querySelector(`[data-variant-id="${variant}"]`) as HTMLInputElement;
            }

            if(variantFormInput && variantFormInput.dataset.hasGift !== 'false') {
                hasGift = true;
            }

            const productItem = {
                id: variant,
                quantity: this.quantity,
                properties: properties,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                selling_plan: sanitizedPlan
            };

            // Check if there are free gifts to add with product. Note these get removed in CartMain
            if (freeGifts.length === 0 || !hasGift || freeGifts == undefined) {
                // Add to cart
                await cart.addItem(productItem).catch((event: unknown | null) => {
                    if (event instanceof Error) {
                        // this.showError(event.message);
                        window.console.warn('Filtering Error.');
                    }
                });
            } else {

                const giftIds = [];
                const freeGiftQty = freeGifts[0] === freeGifts[1] ? 2 : 1;

                for(const freeGiftId of freeGifts) {
                    giftIds.push({
                        id: freeGiftId,
                        quantity: freeGiftQty,
                        properties: {
                            // eslint-disable-next-line @typescript-eslint/naming-convention
                            _eligibleProductId: String(variant)
                        }
                    });
                    if (freeGiftQty === 2 ) { break; } // Exit loop when free gifts are the same.
                }

                const giftExists = cart.items.find((item) => item.variantId === variant);
                const subscription = submitButtonType.getAttribute('is_subscription');
                let includeGift = true;

                // Add free gift if enabled in 'recharge_content_configuration' metafield with 'has_gift' property.
                const hasGift = submitButtonType.getAttribute('has_gift');
                includeGift = hasGift === 'false' ? false : true;
                // Add gift item only once if it's a 'one time purchase'.
                if (giftExists && subscription === 'false') {
                    includeGift = false;
                }

                const productWithGifts = includeGift ? [productItem, ...giftIds] : [productItem];

                cart.addItems(productWithGifts).catch((event: unknown | null) => {
                    if (event instanceof Error) {
                        this.showError(event.message);
                    }
                });
            }

            const straightToCheckout = submitButtonType.getAttribute('straight-to-checkout')
                ? submitButtonType.getAttribute('straight-to-checkout')
                : 'false';

            if (submitButtonType.getAttribute('side-cart-active') === 'false'
                    && straightToCheckout === 'true') {
                window.location.href = '/checkout';

            }else if (submitButtonType.getAttribute('side-cart-active') === 'false'
                && straightToCheckout === 'false') {
                window.location.href = '/cart';
            }else {
                document.dispatchEvent(new Event('cartOpen'));
            }
        } catch (event) {
            this.$log.error('Cart error', {
                event
            });
            const { message } = event as Error;
            this.showError(message);
        } finally {
            this.loading = false;
        }
    }

    updateFineprint(frequency: string) {
        if (frequency === 'one-time') {
            this.hideFineprintElement();
        } else {
            this.showFineprintElement();
        }
    }

    showFineprintElement() {
        if (this.fineprint) {
            this.fineprint.classList.add('product-form__fineprint--active');
        }
    }

    hideFineprintElement() {
        if (this.fineprint) {
            this.fineprint.classList.remove('product-form__fineprint--active');
        }
    }

}

declare global {
    interface Window {
        shopUrl: string;
    }
}
